// extracted by mini-css-extract-plugin
export default {"lowerBar":"lowerBar_lowerBar__yQzcd","image":"lowerBar_image__7W4sJ","text":"lowerBar_text__ohX8y","title":"lowerBar_title__7Qojs","subTitle":"lowerBar_subTitle__S7KK1"};